import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`

  :root {
    --body-primary: ${({ theme }) => theme.colors.body.primary};
    --body-greyLight: ${({ theme }) => theme.colors.body.greyLight};
    --body-greyDark: ${({ theme }) => theme.colors.body.greyDark};

    --text-primary: ${({ theme }) => theme.colors.text.primary};
    --text-secondary: ${({ theme }) => theme.colors.text.secondary};
    --text-tertiary: ${({ theme }) => theme.colors.text.tertiary};
    --text-primaryTwo: ${({ theme }) => theme.colors.text.primaryTwo};
    --text-inactive: ${({ theme }) => theme.colors.text.inactive};
    
    --button-primary: ${({ theme }) => theme.colors.button.primary};
    --button-secondary: ${({ theme }) => theme.colors.button.secondary};
    --button-tertiary: ${({ theme }) => theme.colors.button.tertiary};
    --button-primaryInactive: ${({ theme }) =>
      theme.colors.button.primaryInactive};
    --button-secondaryDark: ${({ theme }) => theme.colors.button.secondaryDark};
  }

  p {
    margin:0;
    padding:0;
  }
`;

export const StyledButton = styled.button`
  border: none;
  background-color: transparent;
`;

export const PrimaryButton = styled(StyledButton)`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: var(--primary);
  color: var(--primary-foreground);
  font-weight: bold;
  border-radius: 100px;
  cursor: pointer;
  font-weight: 800;
  font-size: 16px;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "")};
`;
